import { FC, ReactElement } from 'react'

import { ParallaxFunctionProps } from './types'

const StaticParallax: FC<ParallaxFunctionProps> = (props): ReactElement => {
  const { imgData, children, classNames, bgPosition } = props
  return (
    <>
      <div className={`parallax-container-static parallax-container-common ${classNames?.banner}`}>
        <div className={`static-parallax-child ${classNames?.banner}`}>
          <section
            className="static-parallax-section"
            style={{ backgroundImage: `url(${imgData.src})`, backgroundPosition: `${bgPosition}` }}
          ></section>
          <div className="static-parallax-children">{children}</div>
        </div>
      </div>
    </>
  )
}

export default StaticParallax
